import React from "react";
import PropTypes from "prop-types";
// import noop from "lodash/noop";
import cx from "classnames";
import { Menu } from "antd";
import FloatingIconButton from "./FloatingIcon";

const MenuItem = Menu.Item;

class PopMenu extends React.PureComponent {
    state = {
        menuVisible: false
    };
    handleClick = e => {
        this.setState(
            {
                menuVisible: false
            },
            () => {
                const { onItemClick } = this.props;
                if (onItemClick) {
                    onItemClick(e);
                }
            }
        );
    };
    render() {
        return (
            <FloatingIconButton
                icon={this.props.icon}
                open={this.state.menuVisible}
            >
                <Menu
                    className={cx("box-shade", "br-3")}
                    mode="inline"
                    style={{ width: 256 }}
                    onSelect={this.handleClick}
                >
                    {(this.props.menuList || []).map(x => (
                        <MenuItem
                            key={x
                                .split(" ")
                                .join("_")
                                .toLowerCase()}
                        >
                            {x}
                        </MenuItem>
                    ))}
                </Menu>
            </FloatingIconButton>
        );
    }
}

PopMenu.propTypes = {
    menuList: PropTypes.array,
    onItemClick: PropTypes.func,
    icon: PropTypes.string
};

export default PopMenu;
